import React from 'react'

export const GlobalLoading: React.FC<{}> = () => (
    <div id='app-loading-wrapper'>
        <div id='app-loading'></div>
    </div>
)
